// src/pages/SmartyHome.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";
// import SmartyVision from "./SmartyVision"; 
// import SmartyVision from "./SmartyAdd"; 

const SmartyHome = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const [activeTab, setActiveTab] = useState("List");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const groups = [
    { id: "Vision & Mission", emoji: "🚀" }, 
    { id: "Entry", emoji: "📝" }, 
    { id: "List", emoji: "🗓️" },           
    { id: "Inventory", emoji: "📦" },       
    { id: "Usage Logs", emoji: "📜" },           
    { id: "Graph", emoji: "📊" },         
    // { id: "Insights", emoji: "💡" },        
  ];

  const menuMap = {
    "List": [
      // { label: "Add New Entry", emoji: "➕", link: "/smarty-add" },
      { label: "All Records", emoji: "🗂️", link: "/smarty-list/all" },
      { label: "Today's List", emoji: "📅", link: "/smarty-list/today" },
      { label: "Month's List", emoji: "🗓️", link: "/smarty-list/month" },
      { label: "Items By Category", emoji: "🏷️", link: "/smarty-list/categories" },
      { label: "By Family Members", emoji: "👨‍👩‍👧‍👦", link: "/smarty-list/byfamily" },
      { label: "Savings", emoji: "🇮🇳", link: "/smarty-list/savings" },  
      { label: "AI Insight", emoji: "🧠", link: "/agenticsim" },
    ],
    Inventory: [
      { label: "All Items", emoji: "📦", link: "/smarty-list/inventory" },
      { label: "Expiring", emoji: "⏳", link: "/smarty-list/expiring" },
      { label: "By Storage", emoji: "🗄️", link: "/smarty-list/location" }, 
      { label: "Kahan Hai?", emoji: "🧭", link: "/smarty-list/location" },
      { label: "Kaisa Hai?", emoji: "🔬", link: "/smarty-list/condition" },
    ],
    "Usage Logs": [
      { label: "Consumed Log", emoji: "🥗", link: "/smarty-list/consumed" },   
      { label: "Wasted Log", emoji: "🗑️", link: "/smarty-list/wasted" },      
      { label: "Given/Donated", emoji: "🎁", link: "/smarty-list/given" }, 
      { label: "Expired", emoji: "⌛", link: "/smarty-list/expired" },
    ],
    Graph: [
      { label: "Consumption Trend", emoji: "📈", link: "/smarty-graph/consumption" },
      { label: "Spend vs Consumed", emoji: "💸", link: "/smarty-graph/spend-consumed" },
      { label: "Spend vs Waste", emoji: "♻️", link: "/smarty-graph/spend-waste" },
      { label: "Monthly Pie Chart", emoji: "🥧", link: "/smarty-graph/pie" },
      { label: "Daily Trends", emoji: "📊", link: "/smarty-graph/line" },
      { label: "Savings Opportunity", emoji: "💰", link: "/smarty-save-more" }, 
    ],
    // Insights: [
    //   { label: "Smart Shopping List", emoji: "🛒", link: "/orderflow-home" },
    //   { label: "Predictive Use", emoji: "📡", link: "/smarty-predictive" },
    //   { label: "Waste Reasons", emoji: "⚠️", link: "/smarty-waste-analysis" },
    // ],
  };

  const buttons = menuMap[activeTab] || [];

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  return (
    <div className="min-h-screen flex flex-col bg-black text-teal-100 font-sans">
        <header className="sticky top-0 z-50 bg-black border-b border-teal-800 px-4 py-2 flex items-center justify-between shadow-md">
        <div>
          <div className="text-xl lg:text-2xl font-bold text-yellow-300">
            🤓 Smarty
          </div>
          <div className="text-[10px] lg:text-base text-teal-400">
            Ghar Ka Data Scientist!
          </div>
        </div>

        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <span className="text-xs text-teal-300">{userName}</span>
              <button
                onClick={handleLogout}
                className="p-2 w-8 rounded-md bg-rose-600 hover:bg-rose-700"
              >
                ⏻
              </button>
            </>
          ) : (
            <button
              onClick={() => navigate("/login")}
              className="px-3 py-1 rounded-full border border-teal-700 text-sm hover:bg-teal-900"
            >
              Login
            </button>
          )}
        </div>

        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="md:hidden p-1 text-xl w-8 text-teal-300"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-black border-b border-teal-800 px-4 py-2">
          {isLoggedIn ? (
            <div className="flex items-center justify-between">
              <span className="text-teal-300 text-xs">{userName}</span>
              <button
                onClick={handleLogout}
                className="rounded-md bg-rose-600 p-1 w-8"
              >
                ⏻
              </button>
            </div>
          ) : (
            <Link to="/login" className="text-teal-300">
              Login
            </Link>
          )}
        </div>
      )}

      <div className="mt-1 px-3 py-2 border-b border-teal-700">
        <div className="grid grid-cols-3 lg:grid-cols-6 gap-1">
            {groups.map((g) => (
            <button
                key={g.id}
                onClick={() => setActiveTab(g.id)}
                className={`flex flex-col items-center justify-center w-full px-2 py-2 rounded-md text-xs sm:text-sm transition 
                ${activeTab === g.id
                    ? "bg-yellow-600 text-black shadow-md"
                    : "bg-teal-800 text-teal-100 hover:bg-teal-900"
                }`}
            >
                <span className="text-xl">{g.emoji}</span>
                <span className="mt-1 text-center">{g.id}</span>
            </button>
            ))}
        </div>
        </div>

        {/* Render Vision content below tabs */}
        <div className="mt-4">
            {/* {activeTab === "Vision & Mission" && <SmartyVision />} */}
            {activeTab === "Vision & Mission" && navigate("/smarty-vision")}
        </div>

        <div className="mt-4">
            {activeTab === "Entry" && navigate("/smarty-add")}
        </div>


      <main className="flex-grow px-4 py-3">
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-2">
          {buttons.map((btn, i) => (
            <button
              key={i}
              onClick={() => navigate(btn.link)}
              className="flex flex-col items-center justify-center bg-teal-900/40 p-3 rounded-xl hover:bg-teal-700 transition shadow-sm text-center"
            >
              <span className="text-2xl">{btn.emoji}</span>
              <span className="mt-1 text-xs text-teal-100">{btn.label}</span>
            </button>
          ))}
        </div>
      </main>

      <footer className="bg-black border-t border-teal-800 text-teal-300 py-4 text-center text-xs">
        © 2025 Think5Whys Global DeepTech Solutions.
        <div className="mt-2 flex justify-center gap-4">
          <Link to="/about-us" className="hover:text-teal-400">About</Link>
          <Link to="/privacy-policy" className="hover:text-teal-400">Privacy</Link>
          <Link to="/terms-of-use" className="hover:text-teal-400">Terms</Link>
          <Link to="/contact-us" className="hover:text-teal-400">Contact</Link>
        </div>
      </footer>
    </div>
  );
};

export default SmartyHome;
